"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ModuleBreakdown() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const values = [{
    numeral: "Communication in leadership\nAudience analysis and message design",
    title: "Strategic AI Integration",
    description: "We don't just deploy tools; we architect workflows. Our modules focus on high-impact automation that preserves human oversight while maximizing operational speed."
  }, {
    numeral: "•Emails, reports, and executive briefs\n•Clarity and tone in professional communication",
    title: "Data-Driven Leadership",
    description: "Transform raw analytics into actionable management strategies. Learn to leverage predictive modeling to anticipate market shifts and team performance trends."
  }, {
    numeral: "Structuring impactful presentations\nConfidence and delivery techniques\n•Managing communication during uncertainty\n•Reputation management strategies",
    title: "Ethical Implementation",
    description: "Navigate the complexities of AI governance. Our framework ensures transparency, bias mitigation, and security are baked into every automated process."
  }, {
    numeral: "•Communicating across digital platforms\n•Personal and corporate branding",
    title: "Future-Proof Scalability",
    description: "Build a foundation that evolves. Our curriculum covers the latest LLMs and automation platforms, ensuring your management toolkit remains relevant as technology advances."
  }];
  return <section data-section-id="3603" id="module-breakdown" className="text-foreground py-[200px] px-6 md:px-10 lg:px-16 relative overflow-hidden bg-muted">
      {}
      <div ref={headerRef} className={`max-w-7xl mx-auto mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-12 gap-4 items-end">
          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-xs tracking-widest uppercase" style={{
            color: "var(--chart-1)"
          }}>
              03 / CURRICULUM
            </span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-default font-bold leading-[0.95] tracking-tight" style={{
            fontSize: "clamp(3rem, 8vw, 8rem)"
          }}>
              <span className="block text-foreground">MODULE</span>
              <span className="block font-serif italic font-light" style={{
              color: "var(--chart-1)"
            }}>
                breakdown
              </span>
            </h2>
          </div>
        </div>
        <div className="mt-12 h-px w-full bg-border" />
      </div>

      {}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {values.map((value, i) => {
        const isFourth = i === 3;
        return <ValueCard key={i} data-index={i} numeral={value.numeral} title={value.title} description={value.description} spanTwo={isFourth} />;
      })}
      </div>
    </section>;
}
function ValueCard({
  numeral,
  title,
  description,
  spanTwo,
  ...rest
}: {
  numeral: string;
  title: string;
  description: string;
  spanTwo?: boolean;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} {...rest} className={`group relative p-8 md:p-10 lg:p-12 border border-border backdrop-blur-md shadow-md transition-all duration-500 ease-out hover:-translate-y-1.5 hover:shadow-2xl rounded-md ${spanTwo ? "lg:col-span-2" : ""} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    backgroundColor: "var(--card)"
  }}>
      {}
      

      {}
      <div className="h-px w-full bg-border mb-6" />

      {}
      <h3 className="font-default font-bold text-foreground mb-4 leading-tight" style={{
      fontSize: "1.75rem"
    }}>
        {title}
      </h3>

      {}
      <p className="font-default text-base leading-relaxed" style={{
      color: "var(--muted-foreground)"
    }}>
        {description}
      </p>

      {}
      <div className="absolute top-0 right-0 w-px h-12 transition-all duration-500 group-hover:h-20" style={{
      backgroundColor: "var(--chart-1)"
    }} />
    </div>;
}